export default __webpack_public_path__ + "static/media/triple-dots.dd4c99b8.svg";